<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >

                    <section class="modal-card-body  "  >

                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-field label="Date" on-border>
                                        &nbsp;
                                        <b-select placeholder="Select a Date" v-model="dateSelected">
                                            <option
                                                    v-for="dateAval in dateAvaliableFormated"
                                                    :value="dateAval"
                                                    :key="dateAval" >
                                                {{ dateAval}}
                                            </option>
                                        </b-select>

                                        &nbsp;
                                        <p class="control">
                                            <b-button class="button is-primary" @click="getDataIMRByDate">Search</b-button>
                                        </p>
                                    </b-field>
                                </div>
                                <div class="level-item">
                                    <b-field label="Document" on-border>
                                        &nbsp;
                                        <b-select placeholder="Select a Date" v-model="docTypeSelected">
                                            <option
                                                    v-for="docAval in docTypeImrAvaliable"
                                                    :value="docAval.id"
                                                    :key="docAval.id" >
                                                {{ docAval.doc_name}}
                                            </option>
                                        </b-select>

                                        &nbsp;
                                        <p class="control">
                                            <b-button class="button is-primary" @click="getDataIMRByDocType">Search</b-button>
                                        </p>
                                    </b-field>
                                </div>
                                <div class="level-item">
                                    <b-field label="Clear" on-border>
                                    <b-button type="is-danger"     outlined @click="setInit">
                                        <b-icon
                                                icon="close"
                                                size="is-small">
                                        </b-icon>
                                    </b-button>
                                    </b-field>
                                </div>
                            </div>
<!--                            <div class="level-right">-->
<!--                                <div class="level-item">-->
<!--                                    <button class="button is-warning">Button</button>-->
<!--                                </div>-->
<!--                                <div class="level-item">-->
<!--                                    <button class="button is-danger">Button</button>-->
<!--                                </div>-->
<!--                            </div>-->
                        </nav>
                    </section>

                </header>
                <section class="modal-card-body"  >
                    <!-- Content ... -->
                    <b-table
                            :data="isEmpty ? [] : dataIMRs"
                            bordered
                            striped
                            narrowed
                            hoverable
                            focusable
                            mobile-cards
                            paginated
                            :per-page="perPage"
                            :current-page.sync="currentPage"
                             >





                            <b-table-column  label="Image"  >
                                <template  v-slot:header="{ column }">
                                    <span class="tag is-success"> {{column.label}} </span>
                                </template>
                                <template v-slot="props">
                                <figure class="image is-64x64"  v-if="props.row.temp_url !== '' ">
                                        <img :src="props.row.temp_url" alt="Image"  @click="imageModal(props.row.temp_url)"  style="cursor: pointer;" >
                                    </figure>
                                    <figure class="image is-64x64" v-else>
                                        <img src="imgnotaval.jpg" alt="Image" else>
                                    </figure>
                                </template>
                            </b-table-column>



                            <b-table-column  label="DVM." v-slot="props" >
                                {{ props.row.dvm }}
                            </b-table-column>

                            <b-table-column  label="DEPARTMENT" v-slot="props" >
                                {{ props.row.department }}
                            </b-table-column>

                            <b-table-column  label="Doc." v-slot="props" >
                                {{ props.row.doctype }}
                            </b-table-column>

                            <b-table-column  label="Date"  v-slot="props">
                                {{ formatDate( props.row.daterec) }}
                            </b-table-column>


                            <b-table-column  label="Time" v-slot="props">
                                {{ props.row.timerec }}
                            </b-table-column>

                            <b-table-column  label="User Rec." v-slot="props">
                                {{ props.row.user_rec }}
                            </b-table-column>


                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>


<!--                    <div class="row columns is-multiline" >-->

<!--                        <div class="column is-4"  v-for="data in dataIMRs " :key="data.filename">-->
<!--                            <div class="card is-shady">-->
<!--                                <div class="card-content">-->
<!--                                    <div class="media">-->
<!--                                        <div class="media-left">-->
<!--                                            <figure class="image is-96x96"  v-if="data.temp_url !== '' ">-->
<!--                                                <img :src="data.temp_url" alt="Image"  @click="imageModal(data.temp_url)"  style="cursor: pointer;" >-->
<!--                                            </figure>-->
<!--                                            <figure class="image is-96x96" v-else>-->
<!--                                                <img src="imgnotaval.jpg" alt="Image" else>-->
<!--                                            </figure>-->


<!--                                        </div>-->
<!--                                        <div class="media-content">-->
<!--&lt;!&ndash;                                            <figure class="image is-64x64" v-if="getFullAvatar(data.filename) !== '' ">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <img :src="getFullAvatar(data.filename) " alt="Image">&ndash;&gt;-->
<!--&lt;!&ndash;                                            </figure>&ndash;&gt;-->
<!--                                            <p class="title is-4 no-padding">{{ data.dvm }} </p>-->
<!--                                            <p class="title is-4 no-padding">{{ data.department }}</p>-->
<!--                                        </div>-->
<!--                                    </div><br>-->

<!--                                    <div class="content">-->


<!--                                        <h4> <b-icon-->
<!--                                                icon="file-document-outline"-->
<!--                                                size="is-small">-->
<!--                                        </b-icon> {{ data.doctype }}</h4>-->
<!--                                        <b-icon-->
<!--                                                icon="calendar-range"-->
<!--                                                size="is-small">-->
<!--                                        </b-icon>-->
<!--                                        <span id="datetime-card" class="is-small"> {{formatDate(data.daterec)}}   {{ data.timerec}} </span>-->
<!--                                        <b-icon-->
<!--                                                icon="account"-->
<!--                                                size="is-small">-->
<!--                                        </b-icon>-->
<!--                                         {{  data.user_rec }}-->
<!--                                        <hr>-->

<!--                                        <p >  </p>-->
<!--                                        <span class="button is-info modal-button" data-target="modal-image2" @click="imageModal(data.temp_url)">Read more..</span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </div>-->





                </section>
                <footer class="modal-card-foot">

                    <b-button type="is-danger"
                              icon-left="close"  @click="closeModal"   >
                        Close
                    </b-button>


                </footer>
            </div>

        </b-modal>

        <b-modal :active.sync="isImageModalActive">
            <p class="image ">
                <img :src=dataUrl>
            </p>
        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
 
    import axios from "axios"
    import { getBaseURLforBackEnd , getConfigAxios , getBaseURLAvartar ,customFormatDate ,callIMRForLocal  }  from '@/utils.js'
    import {mapState} from "vuex";
 


    export default {
        name: "IMRHome",
        computed:{
            ...mapState({
                OPDSelected: state => state.opd_target.opd_selected,
                user_id: state => state.master_data.user_id,
                clientIP:  state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            dateAvaliableFormated: function () {
                 return  this.dateImrAvaliable.map(dat=>{
                     return customFormatDate(dat)
                 })
            },


        },
        methods:{
            setInit(){
                this.dateSelected = null
                this.docTypeSelected = null
                this.dataIMRs = []
            },
            formatDate(dateArg){
                return customFormatDate(dateArg)

                // return  moment(dateArg).format("DD/MM/YYYY")
            },
            getFullAvatar(filename){
                // return dvmID
                const target = this.dataIMRs.find( dat => {
                      return dat.filename ===  filename
                    }
                )
                if (target.avartar_dvm !== ""){
                    return `${getBaseURLAvartar()}/user_${target.dvm_id}/${target.avartar_dvm}`
                }
                return ""
                // return  this.dataIMRs.map(dat=>{
                //     return `${getBaseURLAvartar()}/user_${dat.dvm_id}/${dat.avartar_dvm}`
                // })
            },
            imageModal(dataUrl) {
                if(dataUrl !== "") {
                    this.dataUrl = dataUrl
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
            },
            closeModal(){
                this.isComponentModalActive = false
            },
            loadDocTypeImrAvaliable(){
                const dat =     {
                    "idopd": this.OPDSelected.idopd
                }
                const vm = this
                this.isFullScreenSearching = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/imr_doctypeavaliable`,dat,getConfigAxios())
                    .then((res)=>{
                        vm.docTypeImrAvaliable = res.data
                        vm.isFullScreenSearching = false
                    })
                    .catch( function(err) {
                        vm.isFullScreenSearching = false
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })
            },
            loadDateImrAvaliable(){
                const dat =     {
                    "idopd": this.OPDSelected.idopd
                }
                this.isFullScreenSearching = true
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/imr_dateavaliable`,dat,getConfigAxios())
                    .then((res)=>{
                         vm.dateImrAvaliable = res.data[0]["date"]
                         vm.isFullScreenSearching = false
                    })
                    .catch( function(err) {
                        vm.isFullScreenSearching = false
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })
            },
            getDataIMRByDocType(){
               if(this.user_id) {
                           const dat = {
                               "idopd": this.OPDSelected.idopd,
                               "doctype": this.docTypeSelected,
                               "user": this.user_id,
                               "ip": this.clientIP,
                               "local" :callIMRForLocal()
                           }
                           const vm = this
                           // console.log(JSON.stringify(dat))
                           this.isFullScreenSearching = true
                           axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                           axios.post(`${getBaseURLforBackEnd()}/api/imr_datafordoctyperequire_list`, dat, getConfigAxios())
                               .then((res) => {
                                   vm.dataIMRs = res.data
                                   vm.isFullScreenSearching = false
                               })
                               .catch(function (err) {
                                   if (err.response && err.response.status === 401) {
                                       vm.$router.push('/login')
                                   }
                               })
                               .finally(() => {
                                       vm.isFullScreenSearching = false
                                   }
                               )

               }else{
                   this.$router.push('/login')
                       .catch(()=>{});
               }

            },
            getDataIMRByDate(){

             if(this.user_id) {
                     const dat = {
                         "idopd": this.OPDSelected.idopd,
                         "date": this.dateSelected,
                         "user": this.user_id,
                         "ip": this.clientIP,
                         "local" :callIMRForLocal()
                     }
                     const vm = this

                     this.isFullScreenSearching = true
                     axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                     axios.post(`${getBaseURLforBackEnd()}/api/imr_datafordaterequire_list`, dat, getConfigAxios())
                         .then((res) => {
                             vm.dataIMRs = res.data
                             vm.isFullScreenSearching = false
                         })
                         .catch(function (err) {
                             if (err.response && err.response.status === 401) {
                                 vm.$router.push('/login')
                             }
                         })
                         .finally(() => {
                                 vm.isFullScreenSearching = false
                             }
                         )
             }else{
                 this.$router.push('/login')
                     .catch(()=>{});
             }


            }
        },
        data(){
            return{
                isComponentModalActive : false,
                isFullScreen : true,
                isFullScreenSearching : false,
                dateImrAvaliable: [],
                docTypeImrAvaliable : [],
                dateSelected : null ,
                docTypeSelected : null,
                dataIMRs: [],
                isImageModalActive : false,
                dataUrl : "",
                isEmpty : false,
                perPage : 10,
                currentPage : 1
            }
        }
    }
</script>

<style scoped>
    img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;
    }

    .is-sticky-column-one {
        background: #23d160 !important;
        color: white !important;
    }
    .is-sticky-column-two {
        background: #167df0 !important;
        color: white !important;
    }

</style>